/**
 * Global brand theme — Pharmation (pharmation branch).
 * Use these tokens everywhere. Do not hardcode brand colors in components.
 *
 * Real Pharmation branding: logo/icon cropped from the official lockup
 * (https://staging.meducate.digital/logos/pharmation-lockup.png), colors/
 * font/radius from the Pharmation design system (LOGOS/Archive.html — real
 * tokens from app/ux-system.css, not a proposal). Full reference:
 * clones/pharmation/DESIGN.md.
 *
 * Typeface: Instrument Sans everywhere (fonts.display / fonts.body below —
 * the single source of truth; mirrored in brand/brand.css's
 * --brand-font-display / --brand-font-body). Never hardcode a font-family
 * in a component or stylesheet — reference the token instead, so changing
 * it here changes it across the whole app.
 */

export const brand = {
  id: "pharmation",
  name: "Pharmation",
  logoUrl: "/pharmation-logo-horizontal.png",
  logoWhiteUrl: "/pharmation-logo-horizontal-white.png",
  /** Compact mark — mini drawer + favicon */
  iconUrl: "/icon.png",

  colors: {
    accent: "#1769FF", // Cobalt — logo blue, interactive
    accentHover: "#3157D9", // Iris — deep blue
    accentSoft: "rgba(23, 105, 255, 0.12)",
    accentRing: "rgba(23, 105, 255, 0.22)",
    accentBorder: "rgba(23, 105, 255, 0.4)",
    ink: "#0A1B43", // logo word-mark navy
    muted: "#5A6478",
    line: "rgba(10, 27, 67, 0.13)",
    surface: "#FFFFFF", // Chalk
    surfaceSoft: "rgba(255, 255, 255, 0.92)",
    bg: "#FFFFFF",
    bgElevated: "#FFFFFF",
    critical: "#B42318", // semantic error
    criticalSoft: "rgba(180, 35, 24, 0.12)",
    onAccent: "#FFFFFF",
    secondary: "#18C7B7", // Ember — logo mint, CTA/accents. Fill only, never text (2.12:1 on white)
  },

  fonts: {
    display: '"Instrument Sans", sans-serif',
    body: '"Instrument Sans", sans-serif',
    mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
  },

  /* Mirrors brand.css's --radius / --radius-pill exactly — ONE value for
     every corner radius app-wide, plus the separate fully-round concept.
     Keep numerically identical to brand.css; prefer the CSS var string
     ('var(--radius)') over these raw values wherever a component can take
     a string, so both actually read the same source at runtime. */
  radius: "8px",
  radiusPill: "999px",

  // Solved via the black->target-color CSS filter algorithm (loss ~0 for
  // each — exact or near-exact RGB match), so these tint a black-source
  // icon to the exact brand hex above without needing separate SVG assets.
  iconFilters: {
    muted:
      "brightness(0) saturate(100%) invert(58%) sepia(45%) saturate(248%) hue-rotate(182deg) brightness(57%) contrast(79%)",
    accent:
      "brightness(0) saturate(100%) invert(61%) sepia(83%) saturate(1026%) hue-rotate(193deg) brightness(73%) contrast(187%)",
    ink: "brightness(0) saturate(100%) invert(20%) sepia(31%) saturate(428%) hue-rotate(184deg) brightness(126%) contrast(167%)",
    onAccent: "brightness(0) saturate(100%) invert(100%)",
  },
};

export default brand;
